import { InvitationEmailStatus } from '../data-models/invitation-email-status.model';
import { InvitationEmailResult } from '../response-models/invitation-email-result.model';
import { InvitationResendResult } from '../response-models/invitation-resend-result.model';
import { isRecord } from './is-record';
import { countOrZero, nullableString } from './wire-value-utils';

/** Reads the `data` of an admin invitation resend. */
export function toInvitationResendResult(data: unknown): InvitationResendResult {
  const source = isRecord(data) ? data : {};
  return { resendCount: countOrZero(source['resendCount']), tokenExpiresAt: nullableString(source['tokenExpiresAt']) ?? null };
}

/** Reads the `data` of an admin invitation send-email. */
export function toInvitationEmailResult(data: unknown): InvitationEmailResult {
  const source = isRecord(data) ? data : {};
  return {
    emailStatus: (nullableString(source['emailStatus']) ?? 'sent') as InvitationEmailStatus,
    emailSentAt: nullableString(source['emailSentAt']) ?? null,
    resendCount: countOrZero(source['resendCount']),
  };
}
